import { Badge } from '@capawesome/capacitor-badge';
import {
    type IsSupportedResult,
    type GetBadgeResult,
    type PermissionState,
    type PermissionStatus,
} from './MobileBadge.types';

export const get = async (): Promise<number> => {
    const result = await Badge.get();
    return (result as GetBadgeResult).count;
};

export const set = async (count: number): Promise<void> => {
    await Badge.set({ count });
};

export const increase = async (): Promise<void> => {
    await Badge.increase();
};

export const decrease = async (): Promise<void> => {
    await Badge.decrease();
};

export const clear = async (): Promise<void> => {
    await Badge.clear();
};

export const checkPermissions = async (): Promise<PermissionState> => {
    const result = await Badge.checkPermissions();
    return (result as PermissionStatus).display;
};

export const requestPermissions = async (): Promise<PermissionState> => {
    const result = await Badge.requestPermissions();
    return (result as PermissionStatus).display;
};

export const isSupported = async (): Promise<boolean> => {
    if (!window.CORDOVA) return false;

    if ((await checkPermissions()) !== 'granted') return false;

    const result = await Badge.isSupported();
    return (result as IsSupportedResult).isSupported;
};
